import api from "./http";

const API_URL = `/api/messages`;

function fromApiListResponse(data) {
  if (data && Array.isArray(data["hydra:member"])) {
    return data["hydra:member"]; 
  }
  if (data && Array.isArray(data["member"])) {
    return data["member"]; 
  }
  return Array.isArray(data) ? data : [];
}

function toApiPayload(message) {
  return {
    contenu: message.contenu,
    ticketId: message.ticketId, // On envoie directement l'ID numérique
    dateEnvoi: message.dateEnvoi || new Date().toISOString()
  };
}

export async function getMessagesByTicket(ticketId) {
  const res = await api.get(`${API_URL}?ticketId=${ticketId}`, { 
    headers: { Accept: "application/ld+json" } 
  });
  return fromApiListResponse(res.data);
}

export async function addMessage(message) {
  const res = await api.post(API_URL, toApiPayload(message), {
    headers: { 
      "Content-Type": "application/ld+json",
      Accept: "application/ld+json" 
    }
  });
  return res.data;
}

export async function updateMessage(id, message) {
  const res = await api.patch(`${API_URL}/${id}`, toApiPayload(message), {
    headers: { 
      "Content-Type": "application/merge-patch+json",
      Accept: "application/ld+json" 
    }
  });
  return res.data;
}

export async function deleteMessage(id) {
  await api.delete(`${API_URL}/${id}`);
}
